import React from "react";
import "./LoaderSpinner.css";

export default function LoaderSpinner() {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
}
